import {useCallback, useEffect, useState} from "react";
import {getPricing, updatePricing} from "../pricing.service";

export function usePricing(id) {
  const [pricing, setPricing] = useState();
  const [error, setError] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const fetch = useCallback(async () => {
    try {
      setIsLoading(true);
      setPricing(await getPricing(id));
    } catch (err) {
      setError({
        title: "Failed to fetch pricing!",
        message: err.message,
      });
    } finally {
      setIsLoading(false);
    }
  }, [id]);

  async function edit(data) {
    try {
      setIsLoading(true);
      setPricing(await updatePricing(id, data));
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetch();
  }, [fetch]);

  return {pricing, isLoading, edit, error};
}
